import * as React from "react";
import User from "../../_data/models/User";
import {getSiteUrl} from "../../_helpers/utils";
import {UsersRoutes} from "../../routes";

interface Props {
    profile: User;
    currentUser :User;
}


const MyProfileDetailsComponent = ({profile, currentUser}: Props) => {
    const show = currentUser && profile.id == currentUser.id || profile.isProfessional
    const phoneNumber = profile.phoneNumber();
    const profileUrl = getSiteUrl() + UsersRoutes.short_url(profile.name);
    return (
        <div>
            <div className=" row">
                {profile.fullName &&
                <div className=" large-4 columns">
                    <div className=" text-group">
                        <h5 className=" subheader">
                            <small>Full Name</small>
                        </h5>
                        <p>{profile.fullName}</p>
                    </div>
                </div>
                }
                {profile.gender() != '' &&
                <div className=" large-4 columns">
                    <div className=" text-group">
                        <h5 className=" subheader">
                            <small>Gender</small>
                        </h5>
                        <p>{profile.gender()}</p>
                    </div>
                </div>
                }
                {show && phoneNumber &&
                <div className=" large-4 columns">
                    <div className=" text-group">
                        <h5 className=" subheader">
                            <small>Contact No.</small>
                        </h5>
                        <p>{phoneNumber}</p>
                    </div>
                </div>
                }
            </div>
            {show &&
                <div className=" row">
                    <div className=" large-12 columns">
                        <div className=" text-group">
                            <h5 className=" subheader">
                                <small>Address</small>
                            </h5>
                            <p>{profile.completeAddress()}</p>
                        </div>
                    </div>
                </div>
            }
            {profile.bio &&
            <div className=" row">
                <div className=" large-12 columns">
                    <div className=" text-group">
                        <h5 className=" subheader">
                            <small>Short Description</small>
                        </h5>
                        <p>{profile.bio}</p>
                    </div>
                </div>
            </div>
            }
            <div className=" row">
                <div className=" large-12 columns">
                    <div className=" text-group">
                        <h5 className=" subheader">
                            <small>Profile Url</small>
                        </h5>
                        <p>
                            <a href={profileUrl}>{profileUrl}</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyProfileDetailsComponent;


// WEBPACK FOOTER //
// ./app/client/user/components/MyProfileDetailsComponent.tsx